const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;
const STEP = 1024;

/** Shown wherever the API gives us nothing, so a cell is never blank or `NaN`. */
export const UNKNOWN_VALUE = '—';

/**
 * Human-readable file size. `AgentManagerFile.size` is nullable, and a negative value
 * would be meaningless, so both render as an em dash rather than `NaN B` or `-1 B`.
 */
export const formatFileSize = (bytes: number | null | undefined): string => {
  if (bytes == null || Number.isNaN(bytes) || bytes < 0) return UNKNOWN_VALUE;

  let value = bytes;
  let unit = 0;
  while (value >= STEP && unit < UNITS.length - 1) {
    value /= STEP;
    unit += 1;
  }

  // `parseFloat` on a fixed string drops trailing zeros: 2.00 -> 2, 1.50 -> 1.5.
  return `${parseFloat(value.toFixed(2))} ${UNITS[unit]}`;
};
